import type { FC } from 'react';

import { useCustomerGetCustomerProfile } from '@eneco/dc/hooks';
import { Box, Stack, Text } from '@eneco/sparky';
import { ProfileIcon } from '@eneco/sparky/icons';
import { SensitiveContentComponent } from '@eneco/tracking';

interface Props {
  label: string;
}

export const ProfileArea: FC<Props> = ({ label }) => {
  const { data: profile } = useCustomerGetCustomerProfile();

  if (!profile) return null;

  return (
    <Box paddingY="2" paddingX="5">
      <Stack direction="row" alignY="center">
        <Box paddingRight="2">
          <ProfileIcon />
        </Box>
        <Stack direction="column">
          <SensitiveContentComponent contentMask="masked contact name">
            <Text weight="bold" size="BodyM">
              {profile.contact?.name}
            </Text>
          </SensitiveContentComponent>
          <Text as="p" size="BodyS">
            {profile.customerId}
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};
